import { render, staticRenderFns } from "./StoreInfor.vue?vue&type=template&id=25c64084&scoped=true&"
import script from "./StoreInfor.vue?vue&type=script&lang=js&"
export * from "./StoreInfor.vue?vue&type=script&lang=js&"
import style0 from "./StoreInfor.vue?vue&type=style&index=0&id=25c64084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c64084",
  null
  
)

export default component.exports